import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransactionsService {
  baseUrl = environment.baseUrl;


  constructor(private http: HttpClient) { }

  getTransactions(value: any): Promise<any>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', Authorization: 'Bearer ' + sessionStorage.getItem('_token') || ''
      })
    };
    return  this.http.post( `${this.baseUrl}/api/v1/transacciones/get`,  value, httpOptions).toPromise();
  }
}
